/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EducationProgramImageReference } from '../../models/education-program-image-reference';

export interface GetEducationProgramImageReference$Params {
  educationProgramId: string;
  id: string;
}

export function getEducationProgramImageReference(http: HttpClient, rootUrl: string, params: GetEducationProgramImageReference$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationProgramImageReference>> {
  const rb = new RequestBuilder(rootUrl, getEducationProgramImageReference.PATH, 'get');
  if (params) {
    rb.path('educationProgramId', params.educationProgramId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EducationProgramImageReference>;
    })
  );
}

getEducationProgramImageReference.PATH = '/educationprogram/{educationProgramId}/images/{id}';
